import {openScheme} from '@xc/habi-jsbridge'
import {HiyaVerHost, HiyaWebHost} from 'hiya-common/src/constant'

// 钱包tab枚举
export enum WalletTab {
  金币 = 1,
  钻石,
}

// 币商充值
export const goCoinagencyRecharge = () => {
  openScheme(
    `habi://openWindow?fullscreen=1&external=0&need_user_info=1&url=${HiyaVerHost}/CoinsAgency/recharge`
  )
}
// 币商
export const goCoinagency = () => {
  openScheme(
    `habi://openWindow?fullscreen=1&external=0&need_user_info=1&url=${HiyaVerHost}/habiWallet/Coinagency/list`
  )
}
// 黑名单
export const goRefundList = () => {
  openScheme(
    `habi://openWindow?fullscreen=0&external=0&need_user_info=1&url=${HiyaWebHost}/opActivity/refundList`
  )
}
